import { render, staticRenderFns } from "./TechnologicalIndexModal.vue?vue&type=template&id=3233723c"
import script from "./TechnologicalIndexModal.vue?vue&type=script&lang=js"
export * from "./TechnologicalIndexModal.vue?vue&type=script&lang=js"
import style0 from "./TechnologicalIndexModal.vue?vue&type=style&index=0&id=3233723c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports